import { render, staticRenderFns } from "./EnvironmentList.vue?vue&type=template&id=6bd655f7&"
import script from "./EnvironmentList.vue?vue&type=script&lang=js&"
export * from "./EnvironmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports